import { Link } from 'react-router-dom';
import { CLIENT_ROUTES } from '../../../../shared/constants/routes.constants';
import { generatePath } from '../../../../shared/services/app.shared-service';
import { useLocale } from '../../hooks/useLocale';
import HeaderImageTitle from '../header/HeaderImageTitle';
import AllRightsReserved from './AllRightsReserved';

export default function Footer() {
	const { t } = useLocale('client.footer');
	const { t: tGeneric } = useLocale('generic');

	return (
		<footer className="bg-secondary text-primary-foreground py-8">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-8">
					<div className="flex flex-col gap-4">
						<HeaderImageTitle />
						<p className="text-sub-title mb-4">
							{t('companyDescription')}
						</p>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4">
							{t('shop')}
						</h4>
						<ul className="space-y-2 text-muted">
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.PRODUCTS.BASE],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('allProducts')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [
											CLIENT_ROUTES.PRODUCTS.BASE,
											CLIENT_ROUTES.PRODUCTS.RECOMMENDED,
										],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('recommended')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [
											CLIENT_ROUTES.PRODUCTS.BASE,
											CLIENT_ROUTES.PRODUCTS.SALE,
										],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('sale')}
								</Link>
							</li>
							{/* <li>
								<Link
									to={generatePath({
										route: [
											CLIENT_ROUTES.CATEGORIES
										],
									})}
									className="hover:text-white transition-colors"
								>
									{tGeneric('categories')}
								</Link>
							</li> */}
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4">
							{tGeneric('support')}
						</h4>
						<ul className="space-y-2 text-muted">
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.CONTACT],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('contact')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.QNA],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('qna')}
								</Link>
							</li>
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-semibold mb-4">
							{tGeneric('company')}
						</h4>
						<ul className="space-y-2 text-muted">
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.ABOUT_US],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('aboutUs')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [
											CLIENT_ROUTES.ARCHITECTS_DESIGNERS,
										],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('architectsDesigners')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.AUTH],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('adminPortal')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.PRIVACY_POLICY],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('privacyPolicy')}
								</Link>
							</li>
							<li>
								<Link
									to={generatePath({
										route: [CLIENT_ROUTES.TERMS_OF_SERVICE],
									})}
									className="hover:text-primary-foreground transition-colors">
									{tGeneric('termsAndConditions')}
								</Link>
							</li>
						</ul>
					</div>
				</div>

				<div className="border-t border-secondary mt-8 pt-8 text-center text-muted">
					<AllRightsReserved />
				</div>
			</div>
		</footer>
	);
}
